module.exports = __webpack_public_path__ + "img/Picture1opt.3e314e4b.jpg";